import React from 'react';
import { Box, Button, CircularProgress, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import CommonModal from '@/components/customModal/commonModal/commonModal';
import { useFileListsStyles } from './fileLists.styles';

interface IEditTagModalProps {
  open: boolean;
  tag: any;
  updating?: boolean;
  onClose: () => void;
  onChange: (e: any) => void;
  onUpdate: () => void;
}

const EditTagModal: React.FC<IEditTagModalProps> = ({
  open,
  tag,
  updating = false,
  onClose,
  onChange,
  onUpdate,
}) => {
  const theme = useTheme();
  const classes = useFileListsStyles(theme).editTagModal;
  return (
    <CommonModal open={open} onClose={onClose} title="Edit Tag" maxWidth="xs">
      <Box sx={classes.fieldWrap}>
        <TextField
          value={tag?.label || ''}
          onChange={onChange}
          size="small"
          variant="outlined"
          fullWidth
          placeholder="Tag name"
        />
      </Box>
      <Box sx={classes.actionsRow}>
        <Button
          size="small"
          variant="contained"
          color="primary"
          disabled={updating}
          onClick={onUpdate}
          sx={classes.updateButton}
          startIcon={
            updating ? <CircularProgress size={16} color="inherit" /> : null
          }
        >
          {updating ? 'Updating...' : 'Update'}
        </Button>
      </Box>
    </CommonModal>
  );
};

export default EditTagModal;
